export default __webpack_public_path__ + "static/media/transition3.31f1b355.mp3";